module.exports = __webpack_public_path__ + "static/kpmobil-mockup-new-5499bfc997b4fe27db8bf123d8c82779.png";